<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap" rel="stylesheet">

<div class="direction overflow-hidden main-bg">
    <!-- class="navbarScr" [ngClass]="{'hidden-navbar': isNavbarHidden}" -->
    <app-navbar></app-navbar>
    <div class="min-vh-100" [scrollTop]="scr()"> 
        <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
    <app-footer></app-footer> 
    <i class="fa-solid fa-arrow-up-long toTop shadow" (click)="toTop()"></i>
</div>

<!-- Login Modal -->
<app-login></app-login>

<!-- <div class="ComingSoon d-flex justify-content-center align-items-center">
    <h1 class="text-primary fw-bolder fst-italic"> Coming Soon </h1>
</div> -->